<div class="container-fluid d-flex p-0">
  <app-side-bar></app-side-bar>
  <!-- <app-contentpopup [contentPopups]="contentPopups" [content_value]="content_value" [contentKey]="contentKey"
    [contentTableArray]="contentTableArray" [content_Details]="content_Details"
    (closecontentpopup)="closecontentpopup()" [tablevalues]="tablevalues" [tablekeys]="tablekeys">
  </app-contentpopup> -->

  <div class="container-fluid">
    <!-- SAME HEADER -->
    <div class="container-fluid my-3">
      <div class="top-card">
        <div class="row w-100 mx-auto d-flex">
          <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
            <span>LMS DS Manual Entry</span>
          </div>
        </div>
      </div>
    </div>

    <!-- <p class="total-count">Total Count :- {{ total_count }}</p> -->

    <!-- SAME SEARCH UI -->
    <div class="card search-card">
      <div class="row align-items-center">
        <div class="col-12 col-md-2 my-2">
          <p class="enter-title">Enter The Molecule</p>
        </div>

        <div class="col-12 col-md-5 my-2 d-flex align-items-center">
          <i class="fa fa-search icon"></i>
          <input class="form-control molecule-input" placeholder="Enter the Molecule Name" [(ngModel)]="searchValue"
            (keydown.enter)="searchMolecule()" autofocus />
        </div>

        <div class="col-12 col-md-1 my-2">
          <button type="button" class="btn btn-submit" (click)="searchMolecule()">
            Submit
          </button>
        </div>

        <div class="col-12 col-md-2 my-2">
          <p-dropdown [options]="submolecules" [(ngModel)]="selectedSubMolecule" placeholder="Select NDA"
            optionLabel="name" [style]="{ width: '100%', 'font-size': '12px' }"></p-dropdown>
        </div>

        <div class="col-12 col-md-1 my-2">
          <button type="button" class="btn btn-clear" (click)="clearFilter()">
            Clear
          </button>
        </div>
      </div>
    </div>

    <!-- NEW MODULE -->
    <div class="card manual-entry-card mt-3">

      <div class="row mt-2">
        <div class="col-12 col-md-8 my-2 d-flex align-items-center">
          <p class="enter-title mb-0 me-4 whichfield-label">Unique Which Field</p>

          <div class="whichfield-actions">
            <p-dropdown class="whichfield-dd-wrap" [options]="whichFieldOptions" [(ngModel)]="selectedWhichField"
              placeholder="Select" (onChange)="onWhichFieldChange()">
            </p-dropdown>

            <button type="button" class="btn btn-clear ms-4" (click)="clearAllManualEntry()"
              [disabled]="!selectedWhichField || !currentDef || rows.length === 0">
              Clear All
            </button>
          </div>
        </div>
      </div>

      <form *ngIf="selectedWhichField && currentDef" [formGroup]="manualForm" class="mt-3">
        <div formArrayName="rows">
          <div class="card p-3 mb-3" *ngFor="let row of rows.controls; let i = index" [formGroupName]="i">
            <div class="row">
              <div [class]="(f.key === 'Indication_Details') ? 'col-12 mb-3' : 'col-12 col-md-4 mb-3'"
                *ngFor="let f of currentDef.fields">
                <label class="lbl">{{ f.key }}</label>

                <!-- TEXT -->
                <ng-container *ngIf="f.type === 'text'">
                  <input *ngIf="f.key !== 'Indication_Details'" class="form-control" [formControlName]="f.key"
                    [placeholder]="f.key" />

                  <ckeditor *ngIf="f.key === 'Indication_Details'" [editor]="Editor" [formControlName]="f.key">
                  </ckeditor>
                </ng-container>

                <!-- DATE -->
                <input *ngIf="f.type === 'date'" type="date" class="form-control" [formControlName]="f.key" />

                <!-- FILE (PDF) -->
                <input *ngIf="f.type === 'file'" type="file" accept="application/pdf" class="form-control"
                  (change)="onFileSelected($event, i, f.key)" />

                <small class="err"
                  *ngIf="!['TE Code', 'RLD', 'RS'].includes(f.key) && row.get(f.key)?.touched && row.get(f.key)?.invalid">
                  Required
                </small>
              </div>
            </div>

            <!-- Add/Remove buttons only for allowMultiple -->
            <div class="d-flex justify-content-end gap-2" *ngIf="currentDef.allowMultiple">
              <button type="button" class="btn btn-outline-danger" (click)="removeRow(i)" [disabled]="rows.length <= 1">
                Remove
              </button>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end gap-2" *ngIf="currentDef?.allowMultiple">
          <button type="button" class="btn btn-outline-primary" (click)="addRow()">
            + Add More
          </button>
        </div>

        <div class="text-center mt-3">
          <button type="button" class="btn btn-submit-lg" (click)="submitManualEntry()">
            Submit
          </button>
        </div>
      </form>

    </div>
  </div>
</div>